<template>
  <el-dialog
    title="商品品种"
    :visible.sync="visible"
    width="300px"
    append-to-body
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      label-width="100px"
      :model="ruleForm">
      <el-form-item
        label="品种名称："
        :rules="[{required: true, message: '请输入品种名称', trigger: 'blur'}]"
        prop="className">
        <el-input
          v-model="ruleForm.className"
          placeholder="请输入品种名称"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button
        type="primary"
        :loading="loading"
        @click="addItem">更新</el-button>
      <el-button
        :loading="loading"
        @click="toggleModal(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>

export default {
  name: 'CateEditModal',
  components: { },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      ruleForm: {
        parentClassId: null,
        className: '',
        classId: null
      },
      visible: false,
      option: null
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.ruleForm = {
        className: '',
        classId: null
      }
      this.option = null
    },
    addItem() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          const dispatch = this.ruleForm.classId ? 'updatecategory' : 'addcategory'
          this.$store.dispatch('industry/' + dispatch, {
            payload: {
              ...this.ruleForm
              // classId: this.ruleForm.classId || +Date.now()
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    init(row) {
      this.ruleForm = {
        ...this.ruleForm,
        ...row
      }
      this.toggleModal(true)
    }
  }
}
</script>
